module.exports = __webpack_public_path__ + "static/media/orange.926857d3.png";